import { APP_PDC_URL, API_ASK_TEMPLATES, API_PDC_URL_V1 } from "../../../config";

import { createHttpHeaderWithAuthorization } from "../../services/http-header";
import { callWithRetry } from "../../services/callWithRetry";

export const askConstants = {
  GET_LIST_ASK_ERROR: "GET_LIST_ASK_ERROR",
  GET_LIST_ASK_START: "GET_LIST_ASK_START",
  GET_LIST_ASK_SUCCESS: "GET_LIST_ASK_SUCCESS",

  GET_ANSWER_ASK_ERROR: "GET_ANSWER_ASK_ERROR",
  GET_ANSWER_ASK_START: "GET_ANSWER_ASK_START",
  GET_ANSWER_ASK_SUCCESS: "GET_ANSWER_ASK_SUCCESS",

  GET_COMMUNITY_TEMPLATES_LIST_START: "GET_COMMUNITY_TEMPLATES_LIST_START",
  GET_COMMUNITY_TEMPLATES_LIST_SUCCESS: "GET_COMMUNITY_TEMPLATES_LIST_SUCCESS",
  GET_COMMUNITY_TEMPLATES_LIST_ERROR: "GET_COMMUNITY_TEMPLATES_LIST_ERROR",

  GET_COMMUNITY_TEMPLATE_DETAILS_START: "GET_COMMUNITY_TEMPLATE_DETAILS_START",
  GET_COMMUNITY_TEMPLATE_DETAILS_SUCCESS: "GET_COMMUNITY_TEMPLATE_DETAILS_SUCCESS",
  GET_COMMUNITY_TEMPLATE_DETAILS_ERROR: "GET_COMMUNITY_TEMPLATE_DETAILS_ERROR",

  SAVE_COMMUNITY_TEMPLATE_START: "SAVE_COMMUNITY_TEMPLATE_START",
  SAVE_COMMUNITY_TEMPLATE_SUCCESS: "SAVE_COMMUNITY_TEMPLATE_SUCCESS",
  SAVE_COMMUNITY_TEMPLATE_ERROR: "SAVE_COMMUNITY_TEMPLATE_ERROR"
};

export function getListAsk(includeDrafts, isAllClients=false) {
  return (dispatch, getState) => {
    const auth = getState().auth;
    const main = getState().main;
    const accountantUuidSelected = main.accountantUuidSelected;
    const companyUuidSelected = main.companyUuidSelected;

    const additionalHeaders = {
      "X-Manager-ID": accountantUuidSelected
    };

    return new Promise(function(resolve, reject) {
      dispatch({
        type: askConstants.GET_LIST_ASK_START
      });

      let request = {
        method: "GET",
        url:
          APP_PDC_URL +
          "/api/v1/surveys?includeDrafts=" +
          (includeDrafts ? "true" : "false") +
          "&managerId=" +
          accountantUuidSelected +
          (companyUuidSelected && (main.myType !== "STUDIO" || isAllClients) ? "&itemId=" + companyUuidSelected : ""),
        headers: {
          ...createHttpHeaderWithAuthorization(auth.loginAuth.securityToken),
          ...additionalHeaders
        }
      };

      callWithRetry(
        auth, request, dispatch
      )
        .then(response => {
          dispatch({
            type: askConstants.GET_LIST_ASK_SUCCESS,
            payload: response.data
          });
          resolve(response.data);
        })
        .catch(err => {
          dispatch({
            type: askConstants.GET_LIST_ASK_ERROR,
            error: err.toString()
          });
          reject(err);
        });
    });
  };
}

export function getAnswerAsk(answerId) {  
  return (dispatch, getState) => {
    const auth = getState().auth;
    const main =getState().main;
    const accountantUuidSelected = main.accountantUuidSelected;
    const companyUuidSelected = main.companyUuidSelected;

    const additionalHeaders = {
      "X-Manager-ID": accountantUuidSelected
    };

    if (companyUuidSelected) {
      additionalHeaders["X-Item-ID"] = companyUuidSelected;
    }

    return new Promise((resolve, reject) => {
      
      let request = {
        method: "GET",
        url:
          APP_PDC_URL +
          `/api/v1/answers/${answerId}?managerId=${accountantUuidSelected}&itemId=${companyUuidSelected}`,
        headers: {
          ...createHttpHeaderWithAuthorization(auth.loginAuth.securityToken),
          ...additionalHeaders
        }
      };

      dispatch({
        type: askConstants.GET_ANSWER_ASK_START
      });

      callWithRetry(
        auth, request, dispatch
      )
        .then(async result => {
          if (result.status === 200 || result.status === 202) {
            dispatch({
              type: askConstants.GET_ANSWER_ASK_SUCCESS,
              payload: result.data
            });
          } else {
            dispatch({
              type: askConstants.GET_ANSWER_ASK_ERROR,
              error: result
            });
          }
          resolve(result.data);
        })
        .catch(response => {
          dispatch({
            type: askConstants.GET_ANSWER_ASK_ERROR,
            error: response.toString()
          });
          reject(response);
        });
    });
  };
}

export function getCommunityTemplatesList() {

  return (dispatch, getState) => {
    const auth = getState().auth;
    const accountantUuidSelected = getState().main.accountantUuidSelected;

    const additionalHeaders = {
      "X-Manager-ID": accountantUuidSelected
    };
    return new Promise(function(resolve, reject) {
      dispatch({
        type: askConstants.GET_COMMUNITY_TEMPLATES_LIST_START
      });

      let request = {
        method: "GET",
        url: `${API_ASK_TEMPLATES}?authorId=${accountantUuidSelected}`,
        headers: {
          ...createHttpHeaderWithAuthorization(auth.loginAuth.securityToken),
          ...additionalHeaders
        }
      };

      callWithRetry(
        auth, request, dispatch
      )
        .then(response => {
          dispatch({
            type: askConstants.GET_COMMUNITY_TEMPLATES_LIST_SUCCESS,
            payload: response.data
          });
          resolve(response.data);
        })
        .catch(err => {
          dispatch({
            type: askConstants.GET_COMMUNITY_TEMPLATES_LIST_ERROR,
            error: err.toString()
          });
          reject(err);
        });
    });
  };
}

export function getCommunityTemplateDetail(templateId) {

  return (dispatch, getState) => {
    const auth = getState().auth;
    const accountantUuidSelected = getState().main.accountantUuidSelected;

    const additionalHeaders = {
      "X-Manager-ID": accountantUuidSelected
    };
    return new Promise(function(resolve, reject) {
      dispatch({
        type: askConstants.GET_COMMUNITY_TEMPLATE_DETAILS_START
      });

      let request = {
        method: "GET",
        url: `${API_ASK_TEMPLATES}/${templateId}/?authorId=${accountantUuidSelected}`,
        headers: {
          ...createHttpHeaderWithAuthorization(auth.loginAuth.securityToken),
          ...additionalHeaders
        }
      };

      callWithRetry(
        auth, request, dispatch
      )
        .then(response => {
          dispatch({
            type: askConstants.GET_COMMUNITY_TEMPLATE_DETAILS_SUCCESS,
            payload: response.data
          });
          resolve(response.data);
        })
        .catch(err => {
          dispatch({
            type: askConstants.GET_COMMUNITY_TEMPLATE_DETAILS_ERROR,
            error: err.toString()
          });
          reject(err);
        });
    });
  };
}

export function saveCommunityTemplate(templateId) {

  return (dispatch, getState) => {
    const auth = getState().auth;
    const accountantUuidSelected = getState().main.accountantUuidSelected;

    const additionalHeaders = {
      "X-Manager-ID": accountantUuidSelected
    };

    return new Promise(function(resolve, reject) {
      dispatch({
        type: askConstants.SAVE_COMMUNITY_TEMPLATE_START
      });

      let request = {
        method: "POST",
        url: `${API_PDC_URL_V1}/ask/templates/download/${templateId}/?authorId=${accountantUuidSelected}`,
        headers: {
          ...createHttpHeaderWithAuthorization(auth.loginAuth.securityToken),
          ...additionalHeaders
        }
      };

      callWithRetry(
        auth, request, dispatch
      )
        .then(response => {
          dispatch({
            type: askConstants.SAVE_COMMUNITY_TEMPLATE_SUCCESS,
            payload: response.data
          });
          resolve(response.data);
        })
        .catch(err => {
          dispatch({
            type: askConstants.SAVE_COMMUNITY_TEMPLATE_ERROR,
            error: err.toString()
          });
          reject(err);
        });
    });
  };
}
